import {getScrollWidth} from '../../../utils/other';
import grid from '../../../../styles/_global/grid.json';

const BREAKPOINT = grid.w_1280.full_width;

const MENU_OPEN_CLASS = 'menu-open';
const MENU_CLOSE_CLASS = 'menu-close';

const initHeader = () => {
	const header = document.querySelector( 'body > header' );
	
	if ( !header )
	{
		return;
	}
	
	const toggleMenuButton = document.querySelector( 'button.menu-toggle' );
	
	if ( !toggleMenuButton )
	{
		return;
	}

	let removeCloseClassTimeout = null;

	const removeCloseClass = () => {
		clearTimeout( removeCloseClassTimeout );

		if ( header.classList.contains( MENU_CLOSE_CLASS ) )
		{
			removeCloseClassTimeout = setTimeout( () => {
				header.classList.remove( MENU_CLOSE_CLASS );

				clearTimeout( removeCloseClassTimeout );
			}, 200 );
		}
	};

	const removeHiddenProperties = () => {
		document.documentElement.style.removeProperty( 'padding-right' );
		document.documentElement.style.removeProperty( 'overflow' );
		document.body.style.removeProperty( 'overflow' );
	};
	
	const closeMenu = () => {
		header.classList.remove( MENU_OPEN_CLASS );
		header.classList.add( MENU_CLOSE_CLASS );

		removeCloseClass();
		removeHiddenProperties();
	};
	
	header.addEventListener( 'click', ( evt ) => {
		const contentWraper = evt.target.closest( 'div.content-wrapper' );
		const buttonToggle = evt.target.closest( 'button.menu-toggle' );
		
		if ( header.classList.contains( MENU_OPEN_CLASS ) )
		{
			if ( buttonToggle || !contentWraper )
			{
				closeMenu();
			}
		}
		else if ( buttonToggle )
		{
			const scrollWidth = getScrollWidth();
			
			header.classList.remove( MENU_CLOSE_CLASS );
			header.classList.add( MENU_OPEN_CLASS );
			
			document.documentElement.style.setProperty( 'padding-right', `${scrollWidth}px` );
			document.documentElement.style.setProperty( 'overflow', 'hidden' );
			document.body.style.setProperty( 'overflow', 'hidden' );
		}
	} );

	window.addEventListener( 'resize', () => {
		if ( window.innerWidth >= BREAKPOINT )
		{
			if ( header.classList.contains( MENU_OPEN_CLASS ) )
			{
				header.classList.remove( MENU_OPEN_CLASS );
			}

			if ( header.classList.contains( MENU_CLOSE_CLASS ) )
			{
				header.classList.remove( MENU_CLOSE_CLASS );
			}
			
			removeHiddenProperties();
		}
	} );
};

export {
	initHeader,
};
